import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import LightLogo from '../../assets/img/svg/Light-PeopleSync.svg';
import DarkLogo from '../../assets/img/svg/Dark-PeopleSync.svg';

const Logo = ({ size = 'md', className = '' }) => {
  const { isDark } = useTheme();
  
  const sizeMap = {
    sm: "h-6",
    md: "h-8",
    lg: "h-12",
    xl: "h-16",
  };

  return (
    <img 
      src={isDark ? DarkLogo : LightLogo} 
      alt="PeopleSync Logo" 
      className={`${sizeMap[size] || sizeMap.md} w-auto object-contain ${className}`} 
    />
  );
};

export default Logo;
